import React, { useCallback } from 'react';
import EventTypeCards from '../inputs/EventTypeCards';
import { useAnalytics } from '../../../hooks/useAnalytics';

const EventTypesStep = React.memo(({
  data = {},
  onChange,
  disabled = false
}) => {
  const { eventTypes = [] } = data;
  const analytics = useAnalytics();

  const handleEventTypesChange = useCallback((newEventTypes) => {
    onChange({ ...data, eventTypes: newEventTypes });

    // Track event type selection
    if (newEventTypes.length > 0) {
      analytics.trackEventTypeSelect(newEventTypes, 2);
    }
  }, [data, onChange, analytics]);

  return (
    <div className="space-y-6">
      <div>
        <h3 tabIndex={-1} className="survey-heading text-2xl font-['Space_Grotesk'] font-medium mb-2 text-white">
          What kind of events do you go to?
        </h3>
        <p className="text-sm text-white/60">
          Select all that apply
        </p>
      </div>

      <EventTypeCards
        value={eventTypes}
        onChange={handleEventTypesChange}
        disabled={disabled}
      />
    </div>
  );
});

EventTypesStep.displayName = 'EventTypesStep';

export default EventTypesStep;
